import React, { ReactElement } from 'react'
import { oneOf } from 'prop-types'
import { CallToAction, Heading } from '@scentregroup/ui'
import { incBaseIdentity } from '../../helpers/paths'
import ExternalLink from '../external-link'
import { LinkSectionPropsType, LinkSection } from './link-section'
import * as paths from './paths'
import style from './index.module.scss'
import { trackUniversalFooterLinkClick } from './analytics'

interface PropsType {
  country: string
}

const LOGIN = incBaseIdentity('login')
const REGISTER = incBaseIdentity('register')
const westfieldPlusSection: LinkSectionPropsType = {
  heading: { text: 'Westfield Plus', url: paths.WESTFIELD_PLUS, newTab: true },
  links: [
    { text: 'Login', url: LOGIN, trackingLabel: 'Westfield Plus Login' },
    { text: 'Join', url: REGISTER, trackingLabel: 'Westfield Plus Join link' },
    {
      text: 'Terms and conditions',
      url: paths.TERMS_CONDITIONS_WESTFIELD_PLUS,
      newTab: false,
    },
    {
      text: 'Privacy statement',
      url: paths.PRIVACY_POLICY_WESTFIELD_PLUS,
      newTab: false,
    },
    {
      text: 'FAQs',
      url: paths.FAQS_WESTFIELD_PLUS,
      newTab: true,
    },
  ],
}

export const WestfieldPlusContainer = ({
  country,
}: PropsType): ReactElement => (
  <div className={style.westfieldPlusContainer}>
    {country === 'Australia' && (
      <LinkSection
        heading={westfieldPlusSection.heading}
        links={westfieldPlusSection.links}
        trackers={{ clicked: trackUniversalFooterLinkClick }}
      />
    )}
    <div className={style.joinSection}>
      <Heading type="small" className={style.joinTitle}>
        Get more every day with Westfield Plus
      </Heading>
      <CallToAction
        inverted
        fullWidth
        element={ExternalLink}
        className={style.joinButton}
        url={country === 'Australia' ? REGISTER : paths.WESTFIELD_PLUS}
        data-test-id="subscribe-button"
        aria-label="Join Westfield Plus"
        onClick={() =>
          trackUniversalFooterLinkClick('Westfield Plus Join button')
        }
      >
        Join
      </CallToAction>
    </div>
  </div>
)

WestfieldPlusContainer.propTypes = {
  country: oneOf(['Australia', 'New Zealand']).isRequired,
}
